import { Inject, Injectable, Injector } from '@angular/core';



@Injectable({ providedIn: 'root' })
export class Inventory_ReportService {

  constructor(
    private injector: Injector
  ) {
  }

  public Inventory: Inventory_ReportService = this;

  // injecting lazily in order to avoid circular dependencies
}

